import { __makeTemplateObject, __rest } from "tslib";
import React from 'react';
import styled from 'styled-components';
import { primaryMainColor } from '../../utils/styled-components/color-mixins/color-mixins';
var StyledLink = styled(function (_a) {
    var component = _a.component, props = __rest(_a, ["component"]);
    return React.createElement(component, props);
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: none;\n  border: 0;\n  color: ", ";\n  font: inherit;\n  padding: 0;\n  text-decoration: underline;\n\n  &:hover {\n    cursor: pointer;\n    text-decoration: none;\n  }\n"], ["\n  background: none;\n  border: 0;\n  color: ", ";\n  font: inherit;\n  padding: 0;\n  text-decoration: underline;\n\n  &:hover {\n    cursor: pointer;\n    text-decoration: none;\n  }\n"])), primaryMainColor);
StyledLink.displayName = 'StyledLink';
export { StyledLink };
var templateObject_1;
//# sourceMappingURL=Link.styled.js.map